import Jt from "../util/jt";
const Jt_B = Jt.base;
const ua = navigator.userAgent;

const isIos = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
const isAdr = ua.indexOf('Android') > -1 || ua.indexOf('Linux') > -1;
const inApp = window.JSAPI ? true : false;
const isMQB = ua.indexOf('MQQBrowser') > -1 ? true : false;
const appName = '人民资讯';
const appSlogan = '';
const appLogo = require('common/image/logo_120.png');

const artTypes = {
    '1': 'normal',
    '3': 'video',
    '4': 'audio',
    '5': 'image'
};

export {
    isIos,
    isAdr,
    inApp,
    isMQB,
    artTypes,
    appName,
    appSlogan,
    appLogo
};



// WEBPACK FOOTER //
// ./src/common/constant/index.js